"use client";

import { Button } from "@workspace/ui/components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@workspace/ui/components/dropdown-menu";
import { LanguagesIcon } from "lucide-react";

export function LanguageSwitcher({
  locales,
  onChangeLanguage,
}: {
  locales: Record<string, string>;
  onChangeLanguage: (lng: string) => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild hidden={false}>
        <Button variant="ghost" size="icon">
          <LanguagesIcon className="h-5 w-5" aria-hidden={false} />
          <span className="sr-only">Switch language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {Object.keys(locales).map((locale) => (
          <DropdownMenuItem
            key={locale}
            onClick={() => onChangeLanguage(locale)}
            className="justify-end"
          >
            {locales[locale]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
